<script setup>
import LaisPrimaryButton from 'dashboard/components-next/LaisPrimaryButton.vue';
import { VISIT_FINALIZATION_DIALOG_TEXT } from '../utils/visitFinalizationDialogPresenter';

const emit = defineEmits(['finish']);
</script>

<template>
  <div class="grid gap-2">
    <LaisPrimaryButton class="w-full" size="md" @click="emit('finish', 'done')">
      {{ VISIT_FINALIZATION_DIALOG_TEXT.primaryButton }}
    </LaisPrimaryButton>
    <LaisPrimaryButton
      class="w-full"
      variant="ghost"
      size="md"
      @click="emit('finish', 'not_done')"
    >
      {{ VISIT_FINALIZATION_DIALOG_TEXT.secondaryButton }}
    </LaisPrimaryButton>
  </div>
</template>
